import {AddAPhoto} from "@mui/icons-material";
import {Button} from "@mui/material";
import useRequestedDocumentRepository from "../../../../../../repository/emergency/useRequestedDocumentRepository";
import useDocumentRepository from "../../../../../../repository/document-storage/useDocumentRepository";
import isNull from "../../../../../../mixin/isNull";
import {useEffect, useRef} from "react";
import Compressor from 'compressorjs';
import useAlert from "../../../../../../use/useAlert";

export default function ({requestedDocumentId}) {
    const alert = useAlert();
    const requestedDocumentRepository = useRequestedDocumentRepository();
    const documentRepository = useDocumentRepository();
    /** @type RequestedDocument */
    const requestedDocument = requestedDocumentRepository.findOneById(requestedDocumentId).select();
    const pictureInput = useRef();
    const interval = useRef();

    useEffect(() => {
        return () => clearInterval(interval.current);
    }, []);

    const handleTakePictureClick = () => pictureInput.current.click();

    const handleUpload = e => {
        const file = e.target.files[0];

        if (isNull(file)) {
            alert.warning("Une erreur est survenue.");
            return;
        }

        if (file.type.startsWith("image")) {
            const options = {
                quality: 0.3,

                // Compression success callback: upload the compressed binary blob.
                success: result => submit(result)
            };

            new Compressor(file, options);
        } else {
            // Non-image files are uploaded as-is (raw binary).
            submit(file);
        }
    }

    const submit = async file => {
        // First store the raw binary in service-document-storage and get back its id.
        const documentId = await documentRepository.uploadFile(file);

        if (isNull(documentId)) {
            alert.error("Échec de l'upload du document.");
            return;
        }

        // Then link that document id to the requested document in service-emergency.
        await requestedDocumentRepository.update(requestedDocument.getId(), "document_id", {
            requested_document: {
                document_id: documentId
            }
        });

        interval.current = setInterval(() => {
            requestedDocumentRepository.findOneById(requestedDocumentId).exec(false);
        }, 3000);
    }

    if (isNull(requestedDocument)) return null;

    return (
        <>
            <Button
                startIcon={<AddAPhoto/>}
                variant="contained"
                fullWidth
                onClick={handleTakePictureClick}
            >
                {requestedDocument.getName()}
            </Button>
            <input
                ref={pictureInput}
                style={{display: "none"}}
                type={"file"}
                accept="*/*"
                onChange={handleUpload}
                data-test="input-file"
            />
        </>
    )
}